/** @jsx jsx */
import React, { useCallback } from 'react';
import { css, jsx, SerializedStyles } from '@emotion/core';
import { DropTargetMonitor } from 'react-dnd';

import FileDnDProvider from 'components/atoms/FileDnDProvider';
import FileDnDBox from 'components/atoms/FileDnDTarget';

const FileDnDLayer: React.FC<{
  setFile: (file: File) => void
  setActive: (isActive: boolean) => void
  fullWidth?: boolean,
  customStyle?: SerializedStyles
}> = ({
  children, setFile, setActive, fullWidth, customStyle
}) => {
  // DnD時の処理
  const onDrop = useCallback((item: any, monitor: DropTargetMonitor) => {
    if (monitor) {
      const { files } = monitor.getItem();
      setFile(files[0]);
    }
  }, [setFile]);

  return (
    <FileDnDProvider>
      <FileDnDBox
        onDrop={onDrop}
        setActive={setActive}
        fullWidth={fullWidth}
        customStyle={customStyle}
      >
        {children}
      </FileDnDBox>
    </FileDnDProvider>
  );
};

export default FileDnDLayer;
